module.exports = __webpack_public_path__ + "img/promotions-manage.38ca4b65.svg";